import { Component, OnInit, Inject } from '@angular/core';
import { ListBoxItem } from '../../cpq-list-box/ListBoxItem';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IColumn } from '../../common/interfaces/IColumn.interface';

@Component({
    selector: 'cpq-column-selection-dialog',
    templateUrl: './cpq-column-selection-dialog.component.html',
    styleUrls: ['./cpq-column-selection-dialog.component.scss'],
    standalone: false
})
export class CpqColumnSelectionDialogComponent implements OnInit {

  public items = new Array<ListBoxItem>();
  public selectedItems = new Array<number>();
  private allColumnsSelected: boolean;

  constructor(
    public dialogRef: MatDialogRef<CpqColumnSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    let i = 1; // this counter start from 1 because cpq-list-box doesn't recognize if id = 0
    for (const column of this.data.columns.filter((col: IColumn) => !col.hideInColumnSelection)) {
      this.items.push({ id: i, text: column.name, selected: column.visible, isVisible: true, isReadOnly: false });
      if (column.visible) {
        this.selectedItems.push(i);
      }
      i++;
    }
    this.allColumnsSelected = this.selectedItems.length === this.items.length;
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public save() {
    this.data.columns.forEach(element => {
      element.visible = !!this.items.find(x => x.text === element.name && x.selected);
    });

    this.dialogRef.close(this.data.columns);
  }

  toggleSelectAllColumns() {
    this.allColumnsSelected = this.selectedItems.length !== this.items.length;

    this.selectedItems = [];
    this.items.forEach(item => {
      item.selected = this.allColumnsSelected;
      if (this.allColumnsSelected) {
        this.selectedItems.push(item.id);
      }
    });
  }

}
